
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.515 6.217a.77.77 0 00-1.491.378L6.798 21.42a.77.77 0 001.491-.378L4.515 6.217z","fill":"#000"}}),_c('path',{attrs:{"d":"M21.239 11.801l-2.458-9.07c-.088-.327-.244-.679-.829-.714-4.605-.333-7.629 4.253-12.234 3.92-.363-.046-.596.144-.508.47.82 3.024 1.632 6.05 2.458 9.071.132.485.466.669.83.714 4.604.333 7.628-4.253 12.233-3.92.363.046.596-.144.508-.47zM17.625 3.16l.678 2.502c-.969.032-1.823.228-2.73.567l-.677-2.502c.905-.34 1.76-.535 2.73-.567zM8.136 12.51l-.77-2.843c1.018-.03 1.921-.25 2.866-.624L9.554 6.54c.924-.413 1.796-.907 2.668-1.418l.678 2.503c-.872.51-1.744 1.005-2.668 1.418l.77 2.843c-.944.374-1.848.594-2.866.624zm3.555 1.915l-.688-2.539c.917-.41 1.782-.9 2.649-1.407l.688 2.54c-.867.506-1.732.997-2.65 1.406zm1.98-3.957l-.77-2.843c.872-.51 1.744-.997 2.673-1.398l.77 2.843c-.929.401-1.8.889-2.674 1.398zm3.377 1.135l-.688-2.539c.9-.336 1.751-.529 2.713-.56l.689 2.539c-.963.031-1.814.224-2.714.56z","fill":"#000"}})])
          )
        }
      }
    